import { isTokenExpired } from '../utils';
import {
    DELETE_WAITING_LOGIN,
    FREE_PROGRAM_CONFIRM,
    OPEN_BOUNCE_MODAL,
    CLOSE_BOUNCE_MODAL,
    PIN_BOUNCE_SUCCESS,
    PIN_BOUNCE_FAILURE,
    GET_USER_LOCATION_SUCCESS,
    OPEN_SUBMIT_BAND_FINDER_MODAL,
    CLOSE_SUBMIT_BAND_FINDER_MODAL,
    EDIT_BAND_FINDER_PIN,
    OPEN_LOGIN_MODAL,
    CLOSE_LOGIN_MODAL,
    OPEN_TEMP_USER_MODAL,
    CLOSE_TEMP_USER_MODAL,
    TEMP_USER_UPDATE_SUCCESS,
    CHECK_USER_VERIFICATION_SUCCESS,
    GET_USER_DATA_SUCCESS,
    USER_ACTIVATION_SUCCESS,
    GET_USER_PINS_SUCCESS,
    USER_CLEAR_USERDATA
} from '../Actions/users';

import {
    BE_USER_SUCCESS
} from '../Actions/admin';

import { CLOSE_PAYING_METHODS_MODAL, LOCATION_CHANGE } from '../Actions/main';
import { LocalStorageService } from "../Services";

const localStorageUsersObject = LocalStorageService.getState('users') || {};
const token = localStorageUsersObject.token;

const INITIAL_STATE = {
    isLoginModalOpen: false,
    isTempUser: localStorageUsersObject.isTempUser,
    isTempUserModalOpen: false,
    isSignupModalOpen: false,
    isParticipateModalOpen: false,
    isSubmitModalOpen: false,
    submitType: 'liveMusic',
    submitCategory: "openmic",
    token,
    signupTextType: '',
    isLoggedIn: token && !isTokenExpired(token)? true: false,
};

export default function(state = INITIAL_STATE, action) {
    switch (action.type) {
        case OPEN_LOGIN_MODAL:
            return {...state, isLoginModalOpen: true, isSignupModalOpen: false, isParticipateModalOpen: false, signupTextType: ''};
        case CLOSE_LOGIN_MODAL:
            return {...state, isLoginModalOpen: false, loginMessage: ""};
        case OPEN_TEMP_USER_MODAL:
            return {...state, isTempUserModalOpen: true, isSignupModalOpen: false, isParticipateModalOpen: false, signupTextType: ''};
        case CLOSE_TEMP_USER_MODAL:
            return {...state, isTempUserModalOpen: false, loginMessage: ""};

        case 'OPEN_SIGNUP_MODAL':
            return {
                ...state,
                isSignupModalOpen: true,
                isLoginModalOpen: false,
                isParticipateModalOpen: false,
                signupTextType: action.signupTextType ? action.signupTextType : ''
            };
        case 'CLOSE_SIGNUP_MODAL':
            return {...state, isSignupModalOpen: false, signupMessage: '', signupTextType: ''};
        case 'OPEN_PARTICIPATE_MODAL':
            return {...state, isParticipateModalOpen: true, isLoginModalOpen: false, isSignupModalOpen: false, signupTextType: ''};
        case 'CLOSE_PARTICIPATE_MODAL':
            return {...state, isParticipateModalOpen: false, signupMessage: ""};
        case 'OPEN_SUBMIT_MODAL':
            return {...state, isParticipateModalOpen: false, isSubmitModalOpen: true, submitType: action.submitType, editMode: false};
        case 'CLOSE_SUBMIT_MODAL':
            return {...state, isSubmitModalOpen: false, editMode: false, editPinData: null};
        case OPEN_SUBMIT_BAND_FINDER_MODAL:
            return {...state, isParticipateModalOpen: false, isSubmitBandFinderModalOpen: true, editMode: false, submitType: action.submitType};
        case CLOSE_SUBMIT_BAND_FINDER_MODAL:
            return {...state, isSubmitBandFinderModalOpen: false, editMode: false, editPinData: null};
        case 'CHOOSE_SUBMIT_CATEGORY':
            return {...state, submitCategory: action.category};
        case 'LOGIN_REQUEST':
            return {...state, loginFetch: true, isSubmitModalOpen: false};
        case 'LOGIN_SUCCESS':
            return {
                ...state,
                token: action.token,
                isTempUser: action.isTempUser,
                isVerified: action.isVerified,
                isLoggedIn: true,
                loginFetch: false,
                isLoginModalOpen: false
            };
        case TEMP_USER_UPDATE_SUCCESS:
            return {
                ...state,
                token: action.token,
                email: action.email,
                isTempUser: false
            };
        case 'LOGIN_FAILURE':
            return {...state, loginFetch: false,isLoggedIn: false, loginMessage: action.error && action.error.message};
        case 'LOGIN_TEMP_REQUEST':
            return {...state, loginFetch: true, isSubmitModalOpen: false};
        case 'LOGIN_TEMP_SUCCESS':
            return {...state, token: action.token, isLoggedIn: true, loginFetch: false, isLoginModalOpen: false};
        case 'LOGIN_TEMP_FAILURE':
            return {...state, loginFetch: false, loginMessage: action.error && action.error.message};
        case 'SIGNUP_REQUEST':
            return {...state, signupFetch: true, isSubmitModalOpen: false};
        case 'SIGNUP_SUCCESS':
            return {
                ...state,
                isVerified: action.isVerified,
                token: action.token,
                isLoggedIn: true,
                signupFetch: false,
                isSignupModalOpen: false,
                signupTextType: ''
            };
        case 'SIGNUP_FAILURE':
            return {...state, signupFetch: false, signupMessage: action.error && action.error.message};
        case 'SIGN_OUT':
            return {...INITIAL_STATE, isLoggedIn: false, token: '', isTempUser: false, isVerified: false};
        case 'USER_PINS_REQUEST':
            return {...state, fetchingUserPins: true};
        case 'USER_PINS_SUCCESS':
            return {...state, myPins: action.pins, fetchingUserPins: false};
        case 'USER_PINS_FAILURE':
            return {...state, fetchingUserPins: false};
        case 'SAVE_PIN_REQUEST':
            return {...state, savingPin: true};
        case 'SAVE_PIN_SUCCESS':
            return {...state, pinssavingPin: false, isSubmitModalOpen: false, isSubmitBandFinderModalOpen: false, pinDataWaiting: null, filesWaiting: null, editMode: false};
        case 'SAVE_PIN_FAILURE':
            return {...state, savingPin: false};
        case 'REMOVE_PIN_REQUEST':
            return {...state, removingPin: true};
        case 'REMOVE_PIN_SUCCESS':
            return {...state, removingPin: false};
        case 'REMOVE_PIN_FAILURE':
            return {...state, removingPin: false};
        case 'EDIT_PIN':
            return {...state, editMode: true, editPinData: action.pin, isSubmitModalOpen: true, submitType: action.pin.type};
        case EDIT_BAND_FINDER_PIN:
            return {...state, editMode: true, editPinData: action.pin, isSubmitBandFinderModalOpen: true, submitType: action.pin.type};
        case 'SUBMIT_WAITING_LOGIN':
            return {...state, pinDataWaiting: action.pin, filesWaiting: action.files};
        case DELETE_WAITING_LOGIN:
            return {...state, pinDataWaiting: {}, filesWaiting: {}};
        case FREE_PROGRAM_CONFIRM:
            return {...state, programActivated: action.isActivated, programType: action.programType};
        case BE_USER_SUCCESS:
            return {...state, token: action.response.data.token};
        case CLOSE_PAYING_METHODS_MODAL:
            return {...state, pinDataWaiting: null, filesWaiting: null};
        case LOCATION_CHANGE:
            return {
                ...state,
                isLoginModalOpen: false,
                isSignupModalOpen: false,
                signupTextType: '',
                isParticipateModalOpen: false,
                isSubmitModalOpen: false,
                isSubmitBandFinderModalOpen: false
            };
        case PIN_BOUNCE_SUCCESS:
            return {...state, isBounceModalOpen: true};
        case PIN_BOUNCE_FAILURE:
            return {...state, isBounceModalOpen: false};
        case OPEN_BOUNCE_MODAL:
            return {...state, isBounceModalOpen: true};
        case CLOSE_BOUNCE_MODAL:
            return {...state, isBounceModalOpen: false};
        case GET_USER_LOCATION_SUCCESS:
            return {...state, userLocation: action.userLocation};
        case CHECK_USER_VERIFICATION_SUCCESS:
            return {
                ...state,
                isVerified: action.isVerified
            }
        case GET_USER_DATA_SUCCESS:
            return {
                ...state,
                ...action.userData
            }
        case GET_USER_PINS_SUCCESS:
            return {
                ...state,
                myPins: action.userPins
            }
        case USER_ACTIVATION_SUCCESS:
            return {
                ...state,
                isVerified: action.isVerified
            }
        case USER_CLEAR_USERDATA:
            return {
                ...INITIAL_STATE,
                token: '',
                isTempUser: false,
                isLoggedIn: false
            }
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/Reducers/users.js